(() => {
  const init = () => document.querySelectorAll('[data-tse-devices]').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready = 'true';
    const chart = root.querySelector('ts-charge-chart');
    if(!chart) return;
    chart.classList.add('tse-compact');
    const rows = chart.querySelectorAll('tbody tr');
    rows.forEach((row,i) => row.classList.toggle('tse-extra', ![2,4,7,8].includes(i)));
    root.querySelector('.tse-chart-actions').hidden = false;
    root.querySelector('[data-all-devices]').addEventListener('click', event => {
      const expanded = chart.classList.toggle('tse-expanded');
      if(!expanded) chart.querySelector('[data-family="all"]')?.click();
      event.currentTarget.setAttribute('aria-expanded', String(expanded));
      event.currentTarget.textContent = expanded ? 'Show fewer devices −' : 'See more devices +';
    });
    root.querySelector('[data-compare]').addEventListener('click', event => {
      const compare = chart.classList.toggle('tse-comparing');
      event.currentTarget.setAttribute('aria-pressed', String(compare));
      event.currentTarget.textContent = compare ? 'Show this capacity' : 'Compare capacities';
    });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
